export default __webpack_public_path__ + "static/media/approval-action-img.f37e0441.png";